/* Friendship Circle Hub — Interactions */
(function () {
  'use strict';

  /* ── MOBILE NAV ── */
  const burger = document.getElementById('fc-burger');
  const navLinks = document.getElementById('fc-nav-links');
  if (burger && navLinks) {
    burger.addEventListener('click', function () {
      const open = navLinks.classList.toggle('fc-nav__links--open');
      burger.setAttribute('aria-expanded', open);
    });
  }

  /* ── AMOUNT BUTTONS ── */
  document.querySelectorAll('.fc-amount-grid').forEach(function (grid) {
    grid.addEventListener('click', function (e) {
      const btn = e.target.closest('.fc-amt-btn');
      if (!btn) return;
      grid.querySelectorAll('.fc-amt-btn').forEach(function (b) {
        b.classList.remove('fc-amt-btn--selected');
      });
      btn.classList.add('fc-amt-btn--selected');
      // Clear other-amount input in same card
      const card = btn.closest('.fc-form-card');
      if (card) {
        const other = card.querySelector('.fc-other-amt input');
        if (other) other.value = '';
      }
    });
  });

  /* ── OTHER AMOUNT CLEARS SELECTION ── */
  document.querySelectorAll('.fc-other-amt input').forEach(function (input) {
    input.addEventListener('input', function () {
      const card = input.closest('.fc-form-card');
      if (card) {
        card.querySelectorAll('.fc-amt-btn').forEach(function (b) {
          b.classList.remove('fc-amt-btn--selected');
        });
      }
    });
  });

  /* ── DONATION TABS ── */
  document.querySelectorAll('.fc-tab-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      const tab = e.target.closest('.fc-tab');
      if (!tab) return;
      toggle.querySelectorAll('.fc-tab').forEach(function (t) {
        t.classList.remove('fc-tab--active');
      });
      tab.classList.add('fc-tab--active');
    });
  });

  /* ── TRIBUTE TYPE BUTTONS ── */
  document.querySelectorAll('.fc-tribute-grid').forEach(function (grid) {
    grid.addEventListener('click', function (e) {
      const btn = e.target.closest('.fc-tribute-btn');
      if (!btn) return;
      grid.querySelectorAll('.fc-tribute-btn').forEach(function (b) {
        b.classList.remove('fc-tribute-btn--selected');
      });
      btn.classList.add('fc-tribute-btn--selected');
    });
  });

  /* ── E-CARD SELECTION ── */
  document.querySelectorAll('.fc-ecards-grid').forEach(function (grid) {
    grid.addEventListener('click', function (e) {
      const card = e.target.closest('.fc-ecard');
      if (!card) return;
      grid.querySelectorAll('.fc-ecard').forEach(function (c) {
        c.classList.remove('fc-ecard--selected');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('fc-ecard--selected');
      card.setAttribute('aria-pressed', 'true');
    });
    // Keyboard support
    grid.querySelectorAll('.fc-ecard').forEach(function (card) {
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }
      });
    });
  });

  /* ── FORM SUBMIT (demo — replace with real payment processor) ── */
  document.querySelectorAll('.fc-btn-submit').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const card = btn.closest('.fc-form-card');
      const selected = card ? card.querySelector('.fc-amt-btn--selected .fc-amt-num') : null;
      const otherInput = card ? card.querySelector('.fc-other-amt input') : null;
      const amount = (otherInput && otherInput.value) ? '$' + otherInput.value : (selected ? selected.textContent : '');
      if (amount && amount !== 'Skip') {
        // Replace this with your real payment processor integration
        alert('Thank you! This is a demo. Connect your payment processor (Stripe, PayPal, etc.) to process ' + amount + ' donations.');
      } else {
        alert('Please select or enter a donation amount.');
      }
    });
  });

})();
